<template>
  <FormSection>
    <BaseAlert class="pa-md-9" type="warning" :outlined="false">
      <template #message>
        <div class="d-block text-center">
          <h3>{{ $t('complaintForm.faqRead') }}</h3>

          <BaseButton class="mt-9" type="black" @click.native="confirm">
            {{ $t('form.confirmText.confirm') }}
          </BaseButton>
        </div>
      </template>
    </BaseAlert>
  </FormSection>
</template>

<script>
import FormSection from '@/js/components/Forms/FormSection.vue'

export default {
  name: 'ComplaintFormReadHelpReminder',
  components: {
    FormSection,
  },
  data() {
    return {
      isConfirmed: false,
    }
  },
  methods: {
    toggleIsConfirmed() {
      this.isConfirmed = !this.isConfirmed
    },
    confirm() {
      this.toggleIsConfirmed()
      this.$emit('confirm', this.isConfirmed)
    },
  },
}
</script>
